import { useEffect, useState } from 'react'
// TODO: take out a global hook during refactoring
export const useClientGridWidth = (): number => {
  const [clientWidth, setClientWidth] = useState(0)

  useEffect(() => {
    const updateClientWidth = () => {
      setClientWidth(window.innerWidth)
    }

    setClientWidth(window.innerWidth)

    window.addEventListener('resize', updateClientWidth)
    return () => window.removeEventListener('resize', updateClientWidth)
  }, [])

  return clientWidth
}
